import React from "react";

export interface ViewerContextShape {
  viewer: jigsaw.Viewer | null;
  bookData: jigsaw.BookData | null;
}

export const ViewerContext = React.createContext<ViewerContextShape>({
  viewer: null,
  bookData: null,
});
